import {Injectable} from '@angular/core'
import {Config} from '../model/config.model'

@Injectable()
export class ConfigService {

  private config: Config

  init(config: Config) {
    this.config = config
  }

  get(): Config {
    return this.config
  }
}

